import styled from 'styled-components';

export const Container = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;

  > a,
  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const ButtonLink = styled.button`
  min-height: 44px;
  position: relative;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.grey.white};
  gap: 8px;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .red {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }

  span {
    font-size: 18px;
  }

  svg {
    width: 36px;
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const GroupLogin = styled.div`
  width: max-content;
  position: absolute;
  right: 0%;
  top: 0%;
  border-radius: 8px;
  overflow: hidden;
  transform: translateX(0%) translateY(2%);
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  background-color: ${({ theme }) => theme.colors.grey[800]};
  z-index: 8;

  > div {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .red {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.primary.main};
      }
    }
  }

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 48px;
    background-color: ${({ theme }) => theme.colors.grey[700]};
    border-top: 1px solid ${({ theme }) => theme.colors.primary.main};

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[800]};
    }
  }
`;
